import React from 'react';
// Core components
import Box from 'components/core/Box';
// Models
import mPlanning from 'models/cpm/planning';
// Custom
import { cpmPlanningDataShape } from 'constants/PropTypesShapes';
import PlanningWeekEdit from 'components/plannings/PlanningWeekEdit';

const PlanningInfo = ({ planning }) => (
  <Box type="defaultBackground" className="p-3">
    <PlanningWeekEdit
      events={mPlanning.slotsToEvents(planning.slots)}
      editable={false}
    />
  </Box>
);

PlanningInfo.propTypes = {
  planning: cpmPlanningDataShape.isRequired,
};

module.exports = PlanningInfo;



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/plannings/PlanningInfo.js